import { getState } from '../../reduxService';
import user from './user/userSlice';
import Macro2Reducers from '../Macro2/store/reducers';
import Macro1Reducers from '../Macro1/store/reducers';
import projectInfo from './projectInfo/projectInfoSlice';

export default {
    user,
    projectInfo,
    Macro2: Macro2Reducers,
    Macro1: Macro1Reducers,
};

export const getUser = () => getState().user;
export const getMacro1 = () => getState().Macro1;
export const getMacro2 = () => getState().Macro2;
export const getProjectInfo = () => getState().projectInfo;
